import React from "react";

const options = [
  { value: "previousPeriod", label: "vs Previous Period" },
  { value: "lastMonth", label: "vs Last Month" },
  { value: "lastYear", label: "vs Last Year" },
  { value: "none", label: "No Comparison" },
];

const ComparisonSelector = ({ value, onChange }) => (
  <select
    className="input w-full sm:w-44 text-sm"
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
);

export default ComparisonSelector;
